const ReferralProductItem = (props) => {
    const { index, categories, products } = props;

    const categoryOptions = categories.map((category) => {
        return `<div class="control-select-option " data-value="${category.id}">${category.name}</div>`;
    }).join('');

    const productOptions = products.map((product) => {
        return `<div class="control-select-option " data-value="${product.id}">${product.name}</div>`;
    }).join('');

    return `
        <div class="grid-row referral__product">
            <div class="grid-col-3 grid-col-6--md grid-col-6--sm grid-col-12--xs">
                <div class="control control--PRODUCT${index}_CATEGORY referral__control" data-id="PRODUCT${index}_CATEGORY" data-name="" data-placeholder="Category">
                    <div class="control-select control-select--single control-select--empty">
                        <input type="text" class="control-select__value" name="" value="" readonly>
                        <div class="control-select-body">
                            <div class="control-select-body__text">
                                <div class="control-select-body__label">Category</div>
                            </div>
                            <span class="control-select-body__arrow icon-arrow-down"></span>
                            <div class="control-select-remove">
                                <div class="control-select-remove__icon"></div>
                            </div>
                        </div>
                        <div class="control-select-options">${categoryOptions}</div>
                    </div>
                </div>
            </div>
            <div class="grid-col-3 grid-col-6--md grid-col-6--sm grid-col-12--xs">
                <div class="control control--PRODUCT${index}_SUBCATEGORY referral__control" data-id="PRODUCT${index}_SUBCATEGORY" data-name="" data-placeholder="Subcategory">
                    <div class="control-select control-select--single control-select--empty">
                        <input type="text" class="control-select__value" name="" value="" readonly>
                        <div class="control-select-body">
                            <div class="control-select-body__text">
                                <div class="control-select-body__label">Subcategory</div>
                            </div>
                            <span class="control-select-body__arrow icon-arrow-down"></span>
                            <div class="control-select-remove">
                                <div class="control-select-remove__icon"></div>
                            </div>
                        </div>
                        <div class="control-select-options"></div>
                    </div>
                </div>
            </div>
            <div class="grid-col-5 grid-col-11--md grid-col-10--sm grid-col-12--xs d-flex">
                <div class="grid-col-9 grid-col-10--md mb--0 pl--0">
                    <div class="control control--PRODUCT${index} referral__control" data-id="PRODUCT${index}" data-name="PRODUCTS[]" data-placeholder="Product">
                        <div class="control-select control-select--single control-select--empty control-select--clear">
                            <input type="text" class="control-select__value" name="PRODUCTS[]" value="" readonly>
                            <div class="control-select-body">
                                <div class="control-select-body__text">
                                    <div class="control-select-body__label">Product</div>
                                </div>
                                <span class="control-select-body__arrow icon-arrow-down"></span>
                                <div class="control-select-remove">
                                    <div class="control-select-remove__icon"></div>
                                </div>
                            </div>
                            <div class="control-select-options">
                                <div class="control-select-search">
                                    <input type="text" class="control-select-search__field" placeholder="Search">
                                </div>
                                ${productOptions}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-col-3 grid-col-2--md mb--0 pr--0">
                    <label class="control control--PRODUCT_QUANTITY${index} referral__control" data-id="PRODUCT_QUANTITY${index}" data-name="PRODUCT_QUANTITY[]" data-min="1" data-max="9" data-step="1">
                        <input type="number" class="control-number" name="PRODUCT_QUANTITY[]" value="1" min="1" max="9" step="1" title="Quantity">
                        <div class="control-number__counter control-number__counter--minus"></div>
                        <div class="control-number__counter control-number__counter--plus"></div>
                    </label>
                </div> 
            </div>
            <div class="grid-col-1 grid-col-2--sm grid-col-12--xs">
                <button type="button" class="button button--wide referral__remove-product"></button>
            </div>
        </div>
    `;
};

export default ReferralProductItem;
